import React from 'react';
import {StyleSheet, Text, View} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Slippage from '../../portfolio/childComponents/slippage';
import {useSelector} from 'react-redux';
import {useRoute} from '@react-navigation/native';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';
import FormTextLabel from '../../../commonComponents/FormTextLabel';

const BuySellBalanceSection = ({
  walletBalance,
  slippage,
  handleSlippage,
  isShowSlippage,
  isLimit,
  isSmileEvent = false,
}) => {
  let route = useRoute();
  const contestId = route?.params?.contestId;

  let contestBalanceData = useSelector(
    ({contestLeaderboardReducer}) =>
      contestLeaderboardReducer?.contestBalanceData,
  );

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 15,
        marginTop: 10,
      }}>
      {GlobalScreens.Event.isShowBalanceInPopUp ? (
        <FormTextLabel
          labelStyles={styles.balanceTitle}
          label={
            isSmileEvent ? 'Token Balance: ' : 'Balance: '
          }>
          <Text style={{color: GlobalScreens.SingleOrder.highlightColor}}>
            {contestId
              ? Math.floor(contestBalanceData?.coins)
              : Math.floor(walletBalance)}
          </Text>
        </FormTextLabel>
      ) : (
        <Text></Text>
      )}
      {isShowSlippage && !isLimit ? (
        <Slippage slippages={slippage} handleSlippage={handleSlippage} />
      ) : null}
    </View>
  );
};

export default BuySellBalanceSection;

const styles = StyleSheet.create({
  balanceTitle: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.secondaryTextColor1,
  },
});
